    const getDate = (term) => {
        if(term === undefined) { return; }
        let date = new Date(term.date);
        date.setHours(term.hour.split(":")[0]);
        date.setMinutes(term.hour.split(":")[1]);
        return  date;
    };

    const getDateWithBufor = (date,bufor) => {
        if(date === undefined) { return; }
        date.setTime(date.getTime() + bufor*60000);
        return date;
    };

    const convertToDate = (dateInput) => {
    if (dateInput instanceof Date) {
        return new Date(dateInput);
    }

    if (typeof dateInput === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
            const d = new Date(dateInput);
            return isNaN(d.getTime()) ? null : d;
        }

        if (/^\d{2}\.\d{2}\.\d{4}$/.test(dateInput)) {
            const [day, month, year] = dateInput.split('.');
            const d = new Date(year, month - 1, day);
            return isNaN(d.getTime()) ? null : d;
        }
    }

    return null;
};

    export {getDate, getDateWithBufor, convertToDate};